import dayjs from 'dayjs';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { PreparePackageFilter } from '../models';
import { API_ATTEND_TRACK_URL } from '@/utils';
import { createBaseQueryWithReauth } from '@/services';

const scheduledPendingService = createApi({
  reducerPath: 'scheduledPendingService',
  baseQuery: createBaseQueryWithReauth(API_ATTEND_TRACK_URL),
  tagTypes: ['SchedulePending'] as const,

  endpoints: (builder) => ({
    getScheduledPendingService: builder.query<
      PaginatedResponse<any>,
      { filters: PreparePackageFilter; paginated: PaginatedRequest }
    >({
      query: ({ filters, paginated }) => {
        const pickupAttendance = filters.pickupAttendance?.trim() || '';

        const params: Record<string, string | number> = {
          dateAgendaFrom: dayjs(filters.dateAgendaFrom).format('DD-MM-YYYY'),
          dateAgendaTo: dayjs(filters.dateAgendaTo).format('DD-MM-YYYY'),
          offset: (paginated.page - 1) * paginated.pageSize,
          limit: paginated.pageSize,
        };

        if (pickupAttendance === 'all_scheduled') {
          params.pickupAttendance = 'all_scheduled';
        } else {
          params.status = 'SCHEDULED_PENDING,PENDING';
          if (pickupAttendance === 'not_visited') {
            params.pickupAttendance = 'not_visited';
          }
        }

        const phoneNumber = filters.phoneNumber?.trim();
        if (phoneNumber) {
          params.phoneNumber = phoneNumber;
        }

        const shippingId = filters.shippingId?.trim();
        if (shippingId) {
          params.shippingId = shippingId;
        }

        return {
          url: '/inboxes',
          params,
        };
      },
      providesTags: ['SchedulePending'],
    }),

    markAsLost: builder.mutation<void, string>({
      query: (inboxId) => ({
        url: `/inbox/${inboxId}/tag`,
        method: 'PATCH',
        body: { tag: 'LOST' },
      }),
      invalidatesTags: ['SchedulePending'],
    }),

    markAsPrepared: builder.mutation<void, string>({
      query: (inboxId) => ({
        url: `/inbox/${inboxId}/tag`,
        method: 'PATCH',
        body: { tag: 'PREPARED' },
      }),
      invalidatesTags: ['SchedulePending'],
    }),
  }),
});

export default scheduledPendingService;
export const {
  useGetScheduledPendingServiceQuery,
  useMarkAsLostMutation,
  useMarkAsPreparedMutation,
} = scheduledPendingService;
